import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('profile', useCollectionsStore())
  nuxtApp.provide('ui', useUiStore())
  nuxtApp.provide('user', useUserStore())
})
